import axios from 'axios';
import request from './request.service';
import store from '../stores';
import { getClientMessage /* , getServerMessage  */ } from '../utils/massage.util';
import StorageService from '../services/storage.service';
// import moment from 'moment'

export default class AuthService {
    // Initializing important variables
    constructor() {
        this.signIn = this.signIn.bind(this);
        this.getProfile = this.getProfile.bind(this);
        this.tokenKey = 'TOKEN';
    }

    async signIn(user) {
        const response = await request.post('/api/account/login.php', user).catch((e) => e);
        if (Number(response.data.result) === 1) {
            this.setToken(response.data);
            this.isStatus(response.data.is_login);
            new StorageService().user_id.set(response.data.user_id);
            new StorageService().user_no.set(response.data.user_no);
            new StorageService().pay_id.set(response.data.pay_id);
        } else {
            getClientMessage('state.signin.failure').then((msg) => alert(msg));
        }
        return response.data;
    }

    async refreshIn() {
        const tokenHelper = (token) =>
            this.getToken() ? this.getToken().token_type + ' ' + this.getToken()[token] : null;
        const headers = {
            headers: { Authorization: tokenHelper('refresh_token'), 'Last-Access-Token': tokenHelper('access_token') },
        };
        const response = await axios.post(store.getState().navigate.get('baseUrl') + '/add_token_api', null, headers);
        // console.log(response)
        // console.log("리프레쉬 토큰")
        const token = this.getToken();
        token.access_token = response.data.access_token;
        this.setToken(token);
    }
    async signOut() {
        try {
            const response = await request.delete('/remove_token_api');
            this.removeToken();
            localStorage.setItem('signout', new Date()); // 세션스토리지 멀티탭공유 로그아웃 처리
            if (response.data.result && Number(response.data.result) === 0) {
                getClientMessage('state.signout.success').then((msg) => alert(msg));
            }
        } catch (e) {
            this.removeToken();
            localStorage.setItem('signout', new Date()); // 세션스토리지 멀티탭공유 로그아웃 처리
            // getClientMessage('error.network.connect').then(msg => alert(msg))
        }
    }
    refreshPolling() {
        let refreshPoling = setInterval(
            function () {
                this.refreshedIn() ? this.refreshIn().catch(() => this.refreshIn()) : clearInterval(refreshPoling);
            }.bind(this),
            this.getToken().expires_in * 1000 - 300000,
        );
    }
    signedIn() {
        const token = this.getToken() ? this.getToken().access_token : null; // GEtting token from localstorage

        const tokenExpired = this.getToken() ? this.isTokenExpired(token) : false;
        return !!token && tokenExpired;
    }
    signProvedIn() {
        //return this.signedIn() ? this.getTokenInfo().data.otp : false
        return this.signedIn() ? this.getTokenInfo().data.otp : false;
    }
    refreshedIn() {
        const token = this.getToken() ? this.getToken().refresh_token : null; // GEtting token from localstorage
        const tokenExpired = this.getToken() ? this.isTokenExpired(token) : false;
        return !!token && tokenExpired;
    }
    isTokenExpired(token) {
        try {
            if (new Date(Date.now()) < new Date(token * 1000)) return true;
            else return false;
        } catch (err) {
            return false;
        }
    }
    isStatus(result) {
        const token = this.getToken() ? this.getToken() : { refresh_token: null };
        token.result = Number(result);
        this.setToken(token);
        return Number(result);
    }
    getTokenInfo() {
        const tokenInfo = this.getToken() ? this.getToken().access_token.split('.')[1] : null;
        // console.log( JSON.parse(atob(tokenInfo)) )
        return tokenInfo ? JSON.parse(atob(tokenInfo)) : false;
    }
    setToken(tokenId) {
        // Saves user token to localStorage
        if (typeof tokenId === 'object') {
            tokenId = JSON.stringify(tokenId);
        }
        return sessionStorage.setItem(this.tokenKey, tokenId);
    }
    getToken() {
        // Retrieves the user token from localStorage
        try {
            return JSON.parse(sessionStorage.getItem(this.tokenKey));
        } catch (err) {
            // console.log("JSON parse failed for lookup of ", this.tokenKey, "\n error was: ", err);
            return null;
        }
    }
    removeToken() {
        return sessionStorage.removeItem(this.tokenKey, window.location.reload());
    }
    getProfile() {
        // Using jwt-decode npm package to decode the token
        return JSON.parse(atob(this.getToken().split('.')[1]));
    }
    checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) {
            // Success status lies between 200 to 300
            return response;
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    }
}
